import React, {useRef, useState} from 'react'
import Button from "../button/button.jsx";
import {FaEye, FaPaperclip} from "react-icons/fa";
import ModalAttaches from "../modal/modal-attaches.jsx";

const InputFile = ({file, setFile, removeFile, title = "Anexar", titleWithFile = "Visualizar", isRemove = true, className = "", accept = ""}) => {
    const inputRef = useRef(null);
    const [showAttachModal, setShowAttachModal] = useState(false);

    const handleClick = () => {
        inputRef.current.click();
    }

    const handleChange = (e) => {
        const raw = e.target.files[0];

        if (raw && setFile) {
            const previewUrl = URL.createObjectURL(raw);

            const dataForModal = {
                name: raw.name,
                type: raw.type,
                extension: raw.type,
                url: previewUrl,
                file: raw
            };

            e.target.value = null;
            setFile(dataForModal);
        }
    };

    return (
        <>
            <div className={className}>
                { !file &&
                    <>
                        <Button target="attach" className="w-full" onClick={handleClick}>
                            <FaPaperclip/>
                            {title}
                        </Button>
                        <input
                            type="file"
                            ref={inputRef}
                            onChange={handleChange}
                            accept={accept}
                            style={{ display: "none" }}
                        />
                    </>
                }
                {
                    file &&
                    <Button target="attached" className="w-full"
                        onClick={() => setShowAttachModal(true)}
                    >
                        <FaEye/>
                        {titleWithFile}
                    </Button>
                }
            </div>

            <ModalAttaches
                open={showAttachModal}
                setOpen={setShowAttachModal}
                file={{...file}}
                {
                    ...(isRemove && {
                        removeFile: () => {
                            setShowAttachModal(false);
                            setTimeout(() => removeFile(), 100)
                        }
                    })
                }
            />
        </>
    )
}

export default InputFile;